'use client';

import { useState } from 'react';
import { RandomReveal } from 'react-random-reveal';
import { MAIL_CONFIG } from '@/lib/config';

interface Props {
  goList: () => void;
  size: number;
  style?: React.CSSProperties;
}
export default function ButtonRight(props: Props) {
  const { goList, size, style } = props;
  const [show, setShow] = useState(false);

  const changeShowEffect = (isShow: boolean) => {
    setShow(isShow);
  };

  const _renderTextItem = (text: string, isLast?: boolean) => {
    return (
      <span style={{ marginRight: isLast ? '0' : '10px' }}>
        <RandomReveal
          isPlaying
          duration={1}
          characters={text}
          revealDuration={1}
        />
      </span>
    )
  }
  return (
    <button
      className='button-right'
      onClick={goList}
      onMouseEnter={() => changeShowEffect(true)}
      onMouseLeave={() => changeShowEffect(false)}
      style={{
        fontSize: `${size * 0.06}px`,
        fontWeight: 700,
        ...style
      }}
    >
      {show
        ? <span>
          {_renderTextItem("LET'S CREATE CHEMISTRY", true)}
        </span>
        : 
        <span className='letter-scrambler'>
          {MAIL_CONFIG}
        </span>
      }
    </button>
  )
}